import { Input, Table } from "antd";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { selectRegion } from "../../../util/store/region/constants";
import { selectPermissions } from "../../../util/store/selectors";
import { ACTION } from "../../../util/varibles/permission";
import { selectSite } from "../../../util/store/site/constants";
import { siteActions } from "../../../util/store/site/reducer";
import { ISite } from "../../../util/varibles/interface";
import { ColumnTemplates } from "../../../util/varibles/template";
import styles from "../style.module.scss";
import { openSitePopup } from "./SiteDetail";

const Sites: React.FC = () => {
    const [search, setSearch] = useState('');
    const [canUpdateLocation] = useSelector(selectPermissions([ACTION.LOCATION.UPDATE]));
    const regions = useSelector(selectRegion.regions);
    const sites = useSelector(selectSite.data);
    const loading = useSelector(selectSite.loading);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(siteActions.gets())
    }, [dispatch]);

    const handleKeyDown = useCallback((e: any) => {
        if (e.key === 'Escape')
            setSearch('')
    }, [])

    const handleClick = useCallback((data: ISite) => {
        openSitePopup(data);
    }, [])

    const dataSource = useMemo(() => sites.filter(({ name }) => {
        return search.length === 0 || name.toLowerCase().includes(search.trim().toLowerCase())
    }), [sites, search]);

    return <div className={styles.content}>
        <div className='flex justify-end mb-10'>
            <Input
                value={search}
                onChange={(e: any) => setSearch(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder='Search by name'
                className={styles.search}
            />
        </div>
        <Table {...{
            rowKey: "id",
            pagination: false,
            columns: [
                ColumnTemplates.Name,
                ColumnTemplates.WorkTime,
                ColumnTemplates.Phone,
                ColumnTemplates.Position,
                ColumnTemplates.Regions(regions),
                {
                    title: 'Capabilities',
                    dataIndex: 'capabilities',
                    key: 'capabilities',
                    render: (data: any) => {
                        if (!Array.isArray(data))
                            return null
                        return data.map(item => item.name).join(', ')
                    }
                },
                ColumnTemplates.Edit({[ACTION.LOCATION.UPDATE]: canUpdateLocation}, handleClick)
            ],
            loading,
            dataSource
        }} />
    </div>;
};

export default Sites;
